import { useState, useEffect } from 'react';
import axios from 'axios';
import { Activity, RefreshCw } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ACTION_COLORS = {
    crear: 'badge-success',
    editar: 'badge-info',
    eliminar: 'badge-error',
    desactivar: 'badge-error',
    entrega: 'badge-warning',
    retorno: 'badge-info',
};

export const Actividad = () => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchLogs = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${API_URL}/api/actividad?limit=200`);
            setLogs(res.data);
        } catch (e) {
            toast.error('Error al cargar actividad');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchLogs(); }, []);

    const formatDate = (iso) => {
        if (!iso) return '-';
        const d = new Date(iso);
        return d.toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' }) +
            ' ' + d.toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' });
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-400"></div>
            </div>
        );
    }

    return (
        <div className="space-y-6 animate-fadeIn" data-testid="actividad-page">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                <div>
                    <h1 className="text-2xl font-bold text-zinc-100">Registro de Actividad</h1>
                    <p className="text-zinc-400 mt-1">Historial de acciones realizadas por los usuarios</p>
                </div>
                <Button variant="outline" onClick={fetchLogs} data-testid="refresh-btn">
                    <RefreshCw className="w-4 h-4 mr-2" /> Actualizar
                </Button>
            </div>

            <Card className="card">
                <CardContent className="p-0">
                    <Table>
                        <TableHeader>
                            <TableRow className="bg-zinc-800/50">
                                <TableHead className="table-header">Fecha</TableHead>
                                <TableHead className="table-header">Usuario</TableHead>
                                <TableHead className="table-header">Módulo</TableHead>
                                <TableHead className="table-header">Acción</TableHead>
                                <TableHead className="table-header">Detalles</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {logs.length > 0 ? logs.map(log => (
                                <TableRow key={log.id} className="table-row">
                                    <TableCell className="table-cell text-xs text-zinc-400 whitespace-nowrap">{formatDate(log.fecha)}</TableCell>
                                    <TableCell className="table-cell font-medium">{log.username}</TableCell>
                                    <TableCell className="table-cell">
                                        <span className="badge-info capitalize">{log.modulo}</span>
                                    </TableCell>
                                    <TableCell className="table-cell">
                                        <span className={ACTION_COLORS[log.accion] || 'badge-info'}>{log.accion}</span>
                                    </TableCell>
                                    <TableCell className="table-cell text-sm text-zinc-400">{log.detalles}</TableCell>
                                </TableRow>
                            )) : (
                                <TableRow>
                                    <TableCell colSpan={5} className="text-center py-8 text-zinc-500">
                                        No hay actividad registrada aún
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </CardContent>
            </Card>
        </div>
    );
};
